import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {
  @Input() progress = 0; //range: 0 to 1
  @Input() customClass = "";
  @Input() secondaryStyleBar:boolean = false;

  constructor() { }

  ngOnInit() {}

}
